function auction_start_watching(customer_id, product_id) {
    //alert("auction_start_watching");
    $.ajax({
        type: 'POST',
        url: 'https://store.3dtotal.com/a/auctions/buyer-start-watching.php',
        data: jQuery.param({
            customer_id: customer_id,
            product_id: product_id
        }),
        cache: false,
        //dataType: 'json',
        success: function(cart) {
            console.log("3dt-watching auction_start_watching succeeded!");
            refresh_watching_status();            
        }
    }); 
}

function auction_stop_watching(customer_id, product_id) {
    //alert("auction_stop_watching");
    $.ajax({
        type: 'POST',
        url: 'https://store.3dtotal.com/a/auctions/buyer-stop-watching.php',
        data: jQuery.param({
            customer_id: customer_id,
            product_id: product_id
        }),
        cache: false,
        //dataType: 'json',
        success: function(cart) {
            console.log("3dt-watching auction_stop_watching succeeded!");
            refresh_watching_status();            
        }
    }); 
}

function refresh_watching_status() {
    //debugger;
    //alert("refreshing css?");
    var links = document.getElementsByTagName("link");
    for (var cl in links)
    {
        var link = links[cl];
        if (link.rel === "stylesheet" && link.href.includes('check-customer-watching-css.php'))
            link.href += "";
    } 
}